import { createContext, useContext, useState, useEffect } from "react";
import backendApi from "./backendApi";
import { useLoading } from "../api/LoadingContext";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const { setLoading } = useLoading();

  const login = async (newToken) => {
    setToken(newToken);

    try {
      setLoading(true);
      const res = await backendApi.get("/auth/me"); // gets user info immediately
      setUser(res.data);
    } catch (err) {
      console.error("Failed to fetch user after login");
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await backendApi.get("/auth/logout");
    } catch (err) {
      console.error("Logout failed:", err);
    } finally {
      setToken(null);
      setUser(null);
    }
  };

  useEffect(() => {
    const checkAuth = async () => {
      try {
        setLoading(true);
        setAuthLoading(true);
        const res = await backendApi.get("/auth/me");
        setToken("valid");
        setUser(res.data);
      } catch (err) {
        setToken(null);
      } finally {
        setLoading(false);
        setAuthLoading(false);
      }
    };

    checkAuth();
  }, [setLoading]);

  return (
    <AuthContext.Provider value={{ token, login, logout, user, authLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
